module.exports = __webpack_public_path__ + "static/media/mouthShrugLower.378c2bf9.obj";